import { useCallback, useState } from 'react';

export default function useChatProfileModalState() {
  const [profileTarget, setProfileTarget] = useState(null);

  const closeProfileModal = useCallback(() => {
    setProfileTarget(null);
  }, []);

  const openAdminProfile = useCallback((payload) => {
    if (!payload) return;
    setProfileTarget({ type: 'admin', payload });
  }, []);

  const openArtistProfile = useCallback((payload) => {
    if (!payload) return;
    setProfileTarget({ type: 'artist', payload });
  }, []);

  const openProfileTarget = useCallback((target) => {
    if (!target || !target.type) return;
    const payload = target.payload ?? target.profile ?? target.data ?? null;
    if (!payload) return;
    setProfileTarget({ type: target.type, payload });
  }, []);

  return {
    profileTarget,
    setProfileTarget,
    closeProfileModal,
    openAdminProfile,
    openArtistProfile,
    openProfileTarget,
  };
}
